import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import PinFixedFill from '@icons/PinFixedFill';
import { NoticeRow } from '@models/notice';
import { Link } from '@router/Link';
import { pressActionEffect } from '@styles/mixin';
import dayjs from 'dayjs';

import styles from './styles.module.scss';

interface Props {
    notice: NoticeRow;
}

function NoticeItem({ notice }:Props) {
    const {
        title, content, createdAt, isPinned,
    } = notice;

    const parsed = document.createElement('div');
    parsed.innerHTML = content;
    const imageOnly = parsed.textContent?.length === 0
        && parsed.querySelectorAll('img').length !== 0;
    const imageUrl = (() => {
        if (imageOnly) {
            const img = parsed.querySelector('img');
            return img ? img.getAttribute('src') : null;
        }
        return null;
    })();
    const contentSummary = (() => parsed.textContent?.slice(0, 50))();
    return (
        <Link activityName='NoticeActivity'
            activityParams={{ noticeId: notice.id }}
            className={styles.container}
            css={pressActionEffect} >
            {isPinned && (
                <div className={styles.pin}>
                    <PinFixedFill size={20}
                        color={colors.white}/>
                </div>
            )}
            <Column spacing={12} className={styles.body}
                fullWidth>
                <Text size='xl' fontWeight='bold' className={styles.title} as='p'>
                    {title}
                </Text>
                {imageUrl && (
                    <Image src={imageUrl}
                        className={styles.image}
                        width={296}
                        height={154}
                        alt={title} />
                )}
                {contentSummary && (
                    <Text color={colors.gray7} ellipsis>
                        {contentSummary}
                    </Text>
                )}
            </Column>
            <div className={styles.footer}>
                <Text color={colors.gray6}>
                    {dayjs(createdAt).format('YYYY.MM.DD')}
                </Text>
            </div>
        </Link>
    );
}
export default NoticeItem;
